import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { Close } from '@mui/icons-material';

import RequestForm from '../forms/request/RequestForm';
import useAppStore from '../../store/app';

export default function Hero() {
  const state = useAppStore((state) => state.hero);
  const startRequestForm = useAppStore((state) => state.startRequestForm);
  const completeRequestForm = useAppStore((state) => state.completeRequestForm);
  const theme = useTheme();

  const lg = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box
      id="hero"
      sx={{
        height: 'calc(100vh - 94px)',
        maxWidth: '1500px',
        width: '80%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '92px',
        [theme.breakpoints.down('md')]: {
          mt: '120px',
          flexDirection: 'column-reverse',
          justifyContent: 'flex-start',
          alignItems: 'center',
        },
        [theme.breakpoints.down('sm')]: {
          gap: '32px',
        },
      }}
    >
      <Box
        sx={{
          width: '500px',
          [theme.breakpoints.down('md')]: {
            pb: '20%',
          },
          [theme.breakpoints.down('sm')]: {
            width: '100%',
            px: '24px',
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: '800',
            fontSize: '48px',
            lineHeight: '1.2',
            [theme.breakpoints.down('sm')]: {
              fontSize: '28px',
            },
          }}
        >
          Vereinfachen Sie Ihre Arbeitsprozesse mit modernsten
        </Typography>

        <Typography
          sx={{
            fontWeight: '800',
            fontSize: '48px',
            lineHeight: '1.2',
            color: 'primary.main',
            [theme.breakpoints.down('sm')]: {
              fontSize: '28px',
            },
          }}
        >
          Webanwendungen
        </Typography>

        <Typography
          sx={{
            mt: '22px',
            fontSize: '16px',
            [theme.breakpoints.down('sm')]: {
              fontSize: '14px',
            },
          }}
        >
          Wir entwickeln Webanwendungen für Unternehmen um Prozesse effizienter
          zu gestalten. Dabei legen wir größten Wert auf intuitives Design und
          reibungslose Abläufe. All unsere Anwendungen laufen auf
          hochverfügbaren Systemen und erfüllen höchste Anforderungen an
          Sicherheit.
        </Typography>

        <Button
          color="primary"
          variant="outlined"
          sx={{
            mt: '32px',
            width: '180px',
            fontSize: '16px',
            fontWeight: '700',
            border: '3px solid',
            borderRadius: '0',
          }}
          onClick={() => startRequestForm()}
        >
          JETZT ANFRAGEN
        </Button>
      </Box>

      <Box
        sx={{
          flexShrink: 999,
          [theme.breakpoints.down('sm')]: {
            pt: '50px',
          },
        }}
      >
        {(state === 'graphics' || !lg) && (
          <Box
            sx={{
              maxWidth: '450px',
              width: '100%',
              aspectRatio: '588 / 420', // Adjust this to match your SVG's actual ratio
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src="/static/hero.svg"
              alt="Webdevelopment"
              style={{ 
                maxWidth: '100%', 
                maxHeight: '100%',
                width: 'auto',
                height: 'auto'
              }}
            />
          </Box>
        )}

        {state === 'form' && lg && <RequestForm />}
      </Box>

      <Dialog open={state === 'form' && !lg} onClose={completeRequestForm}>
        <Button
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
          }}
          onClick={completeRequestForm}
        >
          <Close />
        </Button>

        <DialogContent
          sx={{
            height: '50vh',
            minHeight: '550px',
            maxHeight: '90vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <RequestForm />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
